import { Box, Tooltip } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

export type LabelTooltipFieldProps = {
  label: string | React.ReactNode
  toolTipTitle: string
}

const FieldLabelTooltip = ({ label, toolTipTitle }: LabelTooltipFieldProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
      }}
    >
      {label}

      <Tooltip title={toolTipTitle} placement="right" arrow>
        <InfoIcon fontSize="small" />
      </Tooltip>
    </Box>
  )
}

export default FieldLabelTooltip
